<template>
    <div ref="test_summary" class="test-summary">
        <h2 class="mb-3">{{ $t('lastSee') }}</h2>
        <p>{{ $t('confirmDetails') }}</p>
        <div class="summary-container">
            <div class="summary-box">
                <span v-for="text in texts" :key="text.icon" class="summary-item"><i
                        :class="'icon ' + text.icon"></i><span v-html="text.value"></span></span>
                <span style="display: flex; align-items: center; margin-top: 60px;">
                    <input class="confirm-features" type="checkbox" v-model="confirmFeatures" name="confirm-features">
                    <label class="confirm-features-lbl" for="confirm-features">{{ $t('confirmCheckbox') }}</label>
                </span>
            </div>
            <lottie class="animation" :options="lottieOptions" style="margin:0;" :height="300" :width="300" />
        </div>
    </div>
</template>

<script>
import * as animationData from "@/assets/animations/check-plan.json";
import { escapeHtml } from "@/utils/safeHtml";

export default {
    watch: {
        stepActive: function () {
            if (this.stepActive) {
                this.$refs.test_summary.style.width = "100%";
                this.$refs.test_summary.style.height = "100%";
                this.setTexts();
                if (!this.confirmFeatures) {
                    this.setNextBtnDisabled(true);
                } else {
                    this.setNextBtnDisabled(false);
                }
                return;
            }
            this.$refs.test_summary.style.width = "0";
            this.$refs.test_summary.style.height = "0";
        },

        confirmFeatures: function () {
            if (!this.confirmFeatures) {
                this.setNextBtnDisabled(true);
            } else {
                this.setNextBtnDisabled(false);
            }
        }
    },
    props: {
        stepActive: Boolean,
        currentBroker: Object,
        currentVendor: Object,
        currentChallenge: Object,
        currentPhase: Object,
        setNextBtnDisabled: Function
    },
    data: function () {
        return {
            texts: [],
            confirmFeatures: false,
            lottieOptions: { animationData: animationData.default },
        }
    },
    mounted() {
        if (this.stepActive) {
            this.setTexts();
        }
    },
    methods: {
        setTexts() {
            this.texts = [
                { value: `${this.$t('texts_TestSummary.yourAccountIs')} <b>${escapeHtml(this.currentBroker.identifier)}</b> ${this.$t('texts_TestSummary.from')} <b>${escapeHtml(this.currentBroker.broker.name)}</b>`, icon: 'fa-regular fa-wallet' },
                { value: `${this.$t('texts_TestSummary.youChoose')} <b>${escapeHtml(this.currentChallenge.name)}</b> ${this.$t('texts_TestSummary.from')} <b>${escapeHtml(this.currentVendor.name)}</b>`, icon: 'fa-regular fa-layer-group' },
                { value: `${this.$t('texts_TestSummary.yourBalanceMustBe')} <b>$${this.numberWithCommas(this.currentPhase.initialBalance)}</b> ${this.$t('texts_TestSummary.atStart')}`, icon: 'fa-regular fa-coins' },
                { value: `${this.$t('texts_TestSummary.targetBalance')} <b>$${this.numberWithCommas(this.currentPhase.target)}</b>`, icon: 'fa-regular fa-money-bill' },
                { value: `${this.$t('texts_TestSummary.toSimulate')} <b>${this.$t('texts_TestSummary.step')} ${this.currentPhase.order}</b>`, icon: 'fa-regular fa-shoe-prints' }
            ]
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
}
</script>

<style lang="scss">
.test-summary {
    display: flex;
    flex-direction: column;
    font-family: "Avenir", sans-serif;
    width: 0;
    transition: width 0.09s ease-in-out;
    height: 0;
    overflow: hidden;

    h6 {
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 10px;
        font-family: "Avenir", sans-serif;
    }

    p {
        font-size: 16px;
        margin-bottom: 40px;
        font-family: "Avenir", sans-serif;
    }

    .summary-container {
        display: flex;
        flex-direction: row;
        background-color: var(--v-cardBackground-base);
        border: 1px solid #9A9A9A;
        border-radius: 10px;
        padding: 50px 60px;

        @media (max-width: 768px) {
            padding: 20px 20px;
        }

        align-items: center;
        justify-content: space-between;

        .animation {
            @media (max-width: 768px) {
                display: none;
            }
        }

        .summary-box {
            display: flex;
            flex-direction: column;

            .summary-item {
                font-size: 18px;
                margin-bottom: 12px;

                .icon {
                    font-size: 18px;
                    margin-right: 20px;
                    color: var(--v-mainGreen-base) !important;
                }
            }
        }

    }

    .confirm-features {
        -moz-appearance: none;
        -webkit-appearance: none;
        -o-appearance: none;
        appearance: none;
        border-radius: 5px;
        border: 1px solid #9A9A9A;
        accent-color: var(--v-mainGreen-base);
        margin-right: 20px;
        width: 18px;
        height: 18px;
        transition: box-shadow 0.15s ease-in-out;
        cursor: pointer;

        &:hover {
            box-shadow: 0px 4px 5px 0 rgba(0, 0, 0, 0.25);
        }

        &::before {
            display: block;
            position: relative;
            content: "";
            background-image: url('data:image/svg+xml,<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5879 1.07812C11.9134 1.40365 11.9134 1.93229 11.5879 2.25781L4.92122 8.92448C4.5957 9.25 4.06706 9.25 3.74154 8.92448L0.408203 5.59115C0.0826823 5.26563 0.0826823 4.73698 0.408203 4.41146C0.733724 4.08594 1.26237 4.08594 1.58789 4.41146L4.33268 7.15365L10.4108 1.07812C10.7363 0.752604 11.265 0.752604 11.5905 1.07812H11.5879Z" fill="white"/></svg>');
            color: white;
            background-position: center;
            transform: scale(0);
            background-color: var(--v-mainGreen-base);
            left: -1px;
            top: -2px;
            border-radius: 5px;
            padding: 10px;
        }

        &:checked {
            &::before {
                transform: scale(1);

            }
        }
    }

    .confirm-features-lbl {
        font-size: 16px;
    }

}
</style>